import React from "react";
import { navigate } from "gatsby";
import { Button } from "../button/button";

export function Cta({ ctaLink, ctaText, bgClass }) {
  return (
    <div className={`text-center ${bgClass ? bgClass : ''}`}>
      <Button.BaseButton
        buttonStyle="outline"
        size="2xl"
        className="w-full lg:w-auto"
        onClick={() => { navigate(ctaLink) }}
      >
        <span className="font-semibold">{ctaText}</span>
      </Button.BaseButton>
    </div>
  );
}
